'use client';

import Link from 'next/link';
import { Home, Ship, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  // Use static text since not-found.tsx is outside locale context
  // and cannot access NextIntlClientProvider
  return (
    <div className="max-w-2xl mx-auto py-16 px-4">
      <div className="text-center">
        <h1 className="text-[120px] font-bold text-blue-600 dark:text-blue-400 mb-4">
          404
        </h1>
        <h2 className="text-3xl font-semibold text-slate-900 dark:text-slate-100 mb-4">
          Page Not Found
        </h2>
        <p className="text-base text-slate-600 dark:text-slate-400 mb-8">
          The page you are looking for does not exist.
        </p>
        <div className="flex gap-3 justify-center flex-wrap">
          <Link
            href="/pl"
            className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
          >
            <Home className="w-5 h-5 mr-2" />
            Home
          </Link>
          <Link
            href="/pl/cruises"
            className="inline-flex items-center px-6 py-3 border border-blue-600 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 font-medium rounded-lg transition-colors"
          >
            <Ship className="w-5 h-5 mr-2" />
            Browse Cruises
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center px-6 py-3 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 font-medium rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </button>
        </div>
      </div>
    </div>
  );
}

